import * as React from 'react';
import BigCalendar from 'react-big-calendar';
import * as moment from 'moment';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Subscriber, Broadcast } from 'react-broadcast';
import { Popover } from 'antd';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import withDragDropContext, { getDragCalendar } from '../../../../utils/withDragDropContext';
// import { DatePicker as AntdDatePicker } from 'antd';

require('moment/locale/cs');
moment.locale('cs');

import {
  RendererComponentProps,
  ContextObserver,
  ResourceCollection,
  // Renderer,
  translate,
  Renderer
} from '../../../../webana';

const DragAndDropCalendar = getDragCalendar();

BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
// let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k])

const getCalendarEventComponent = (contentFunction: (event: any) => any) => {
  class CalendarEventComponent extends React.Component<any> {
    render() {
      const event = this.props.event;
      // console.log(event);
      return (
        <Popover
          title={this.props.title}
          placement="leftTop"
          content={contentFunction(event)}
        >
          <div style={{ height: '100%' }}>{this.props.title}</div>
        </Popover>
      );
    }
  }

  return CalendarEventComponent;
};

@observer
class CalendarComponent2 extends React.Component<RendererComponentProps<any> & ContextObserver<any>> {
  getCollection(): ResourceCollection | undefined {
    return this.props.context.resources[this.props.config.resource];
  }
  
  render() {
    const { config, context } = this.props;
    const { router, redirect } = context;
    const vars = router.location.state || {};
    const resource = this.getCollection();
    let events = resource && resource.data ? toJS(resource.data.items) : [];
    vars.calendarDate = moment(vars.calendarDate).toDate() || Date.now();

    const test = (event: any): any => {
      const ctx = { ...context, event };
      return (
        <Broadcast channel="context" value={ctx}>
          <Renderer content={config.tooltipContent} />
        </Broadcast>
      );
    };

    const components = {
      event: getCalendarEventComponent(test)
    };

    const messages = {
      allDay: translate('calendar-all-day'),
      previous: translate('calendar-previous'),
      next: translate('calendar-next'),
      today: translate('calendar-today'),
      month: translate('calendar-month'),
      week: translate('calendar-week'),
      day: translate('calendar-day'),
      agenda: translate('calendar-agenda'),
      date: translate('calendar-date'),
      time: translate('calendar-time'),
      event: translate('calendar-event'),
      showMore: () => translate('calendar-show-more')
    };

    console.log("REnderC2");

    return (
      <div style={{ height: 800 }}>
        <DragAndDropCalendar
          events={events}
          startAccessor={(obj: any) => moment(obj.dRzFr).toDate()}
          endAccessor={(obj: any) => {
              let d = moment(obj.dRzTo).toDate();
              let tmIsZero = (d.getHours() + d.getMinutes() + d.getSeconds() === 0);

              return obj.allDay && tmIsZero ? (d.setHours(23), d.setMinutes(59), d) : d;
            }
          }
          titleAccessor={(obj: any) => {
            if (obj.nsRzCelodenTxt) {
              return <div>{obj.nsZamNazev + " - " + obj.nsRzCelodenTxt}</div>;
            }
            return <div>{obj.nsZamNazev}</div>;
          }}
          step={60}
          showMultiDayTimes={true}
          defaultDate={new Date()}
          selectable={true}
          date={moment(vars.calendarDate).toDate()}
          components={components}
          messages={messages}
          formats={{ eventTimeRangeFormat: () => {''} }}
          onNavigate={(date: any) => redirect(".", { calendarDate: date })}
          view={vars && vars.calendarView || 'week'}
          className="kalendar indispozic"
          onView={(view: string) => redirect(".", { calendarView: view })}
          onSelectSlot={(slot: any) => 
            redirect('/indispositions/new', {start: slot.start, end: slot.end, redirCal: true, calendarDate: slot.start })
          }
          onSelectEvent={(event: any) => {
            redirect('/indispositions/' + event.id, {
              start: null, end: null, redirCal: true, calendarDate: moment(event.dRzFr).toDate()
            })
          }}
          eventPropGetter={() => {
            return {
              style: {
                backgroundColor: "rgb(21, 144, 131)",
                boxShadow: "0 0 5px 2px #10101059"
              }
            }
          }}
        />
      </div>
    );
  }
}

export class CalendarComp2 extends React.Component<RendererComponentProps<any>> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <CalendarComponent2 {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}

export const Calendar2 = withDragDropContext(CalendarComp2);


// WEBPACK FOOTER //
// ./src/modules/calendar/components/calendar2/Calendar2.tsx